import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ConfigService } from 'app/core/services/config.service';
import { OrganizationDetailsService } from '../../../organization-details.service';
import { NotificationService } from 'app/core/services/notification.service';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { SmartModalService, ModalSize } from 'app/core/services/smart-modal.service';
import { AddressEditComponent } from '../address-edit/address-edit.component';

import { trigger, transition, style, animate, state } from '@angular/animations';

declare var $:any;

@Component({
	selector: 'itpx-addresses-manage-grid',
	templateUrl: './addresses-manage-grid.component.html',
	styleUrls: ['./addresses-manage-grid.component.css'],
	animations: [
        trigger('addressesGridAnim', [
                transition(':enter', [
                        style({'max-height': 0}),
                        animate('1s 0.5s ease-out', style({'max-height': '1000px'}))
                ]),
                transition(':leave', [
                        style({'max-height': 1}),
                        animate('0.3s ease-out', style({'max-height': '0'}))
                ])
        ]),
        trigger('formAnim', [
                state('0', style({'max-height': '2000px'})),
                state('1', style({'max-height': '0'})),
                transition('0 => 1', animate('0.5s ease-out')),
                transition('1 => 0', animate('0.5s 0.3s ease-out'))
        ])
    ]
})
export class AddressesManageGridComponent implements OnInit {

	@ViewChild('modalWrapper') modalWrapper: ElementRef;
	@ViewChild('formComponent') formComponent: ElementRef;

	private shippingAddresses:any;
	private billingAddress: any;
	private details: any;
	private addressDetails: any;
	private addressEdit = false;
	private isBillingAddressEdit = false;

	private editClick = new Subject<string>();

	private url: string;
    private detailsRoute: string = '/organization/users/{{key}}/details';
    private fields: Array<any> = [
        {
            title: 'Street Name',
            name: 'streetName',
            config: {
                type: 'link',
                route: this.detailsRoute,
                key: 'id'
            }
        }, {
            title: 'Country',
            name: 'country',
            config: {
                type: 'link',
                route: this.detailsRoute,
                key: 'id'
            }
        }, {
            title: 'State',
            name: 'state'
        }, {
            title: 'Province',
            name: 'province'
        }, {
            title: 'City',
            name: 'city'
        }, {
            title: 'House Number',
            name: 'houseNumber'
		},{
			title: 'Action'
		}

    ];

	constructor(
		private configService: ConfigService,
		private service: OrganizationDetailsService,
		private notificationService: NotificationService,
		private modalService: SmartModalService
	) {
		this.url = this.configService.get('server').url + this.configService.get('endpoints').organization.organizationDetails.details.api;
	 }

	ngOnInit() {

		let defaultShipToAddressId = '';
		this.details = Object.assign({}, this['data']);
		defaultShipToAddressId = this.details.defaultShipToAddress.id;

		this.shippingAddresses = this.markDefaultShipToAddress(defaultShipToAddressId, this.details.shipToAddresses);

		this.details.defaultShipToAddress['isDefaultShipToAddress'] = true;
		this.shippingAddresses.push(this.details.defaultShipToAddress);

		this.billingAddress = this.details.defaultBillToAddress;
	}

	ngOnDestroy() {
		this.shippingAddresses = {};
	}

	private onDeleteAddress(address: any) {
		let index;
		this.shippingAddresses.forEach(function(el, i) {
			if(el.hasOwnProperty('id')) {
				if(el.id === address.id) {
					index = i;
					return index
				}
			}
		});
		if(index >= 0 ) {
			this.shippingAddresses.splice(index, 1);
		}
		this.service.deleteShippingAddress(address.id)
            .subscribe(
                data => {
					this.notificationService.success('Successfully deleted shipping address',  'Success');
                }
            )

	}
	private removeShippingAddresses(index: number) {
		let detailsToSend = this.details;
		detailsToSend['shippingAddresses'] = this.shippingAddresses.splice(index, 1);

		this.service.editAddresses(detailsToSend)
            .subscribe(
                data => {
                    this.notificationService.success('Successfully deleted shipping address',  'Success');
                }
            )
	}

	private onEditAddress(address) {
		this.addressDetails = address;
		this.addressEdit = true;
		this.isBillingAddressEdit = false;
	}

	private onEditDefaultBillingAddress(address) {
		this.addressDetails = address;
		this.addressEdit = true;
		this.isBillingAddressEdit =  true;
	}

	private editIsCancel(){
		this.addressEdit = false;
		$(this.modalWrapper.nativeElement).css('height', 'auto')
	}
	private editIsSaved() {
		this.addressEdit = false;
		$(this.modalWrapper.nativeElement).css('height', 'auto')
	}
	private setModalHeight(height: any) {
		$(this.modalWrapper.nativeElement).css('height', height);
	}
	private markDefaultShipToAddress(defaultShipToAddressId, shippingAddresses) {

		if(defaultShipToAddressId && shippingAddresses) {
			shippingAddresses.forEach(function(address, index) {
				if(address.hasOwnProperty('id') && address['id'] === defaultShipToAddressId) {
					shippingAddresses.splice(index, 1);
					return shippingAddresses
				}
			});
			return shippingAddresses;
		};

	}

}



// WEBPACK FOOTER //
// ./src/app/organization/components/organization-details/organization-details-edit/address/addresses-manage-grid/addresses-manage-grid.component.ts